

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addRule } from '../../../../reducers/JsonRuleEditor/RulesActions';

export default function AddRules({ handleView }) {
    const [addView, setAddView] = useState("upload");
    const [ruleName, setRuleName] = useState('');
    const [file, setFile] = useState(null);
    const [errorMsg, setErrorMsg] = useState('');
    const dispatch = useDispatch();
    
    const handleBack = (type, backTo) => {
        if (backTo === "list") {
            handleView(type);
        } else if (backTo === "upload") {
            handleAddView("upload");
        }
    };

    const handleAddView = (type) => {
        setRuleName('');
        setFile(null);
        setErrorMsg('');
        setAddView(type);
    };
    
    const handleFileUpload = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        
        setFile(selectedFile);
        
        // Optional: Read file content to validate JSON format
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const jsonData = JSON.parse(event.target.result);
                // Validate that it's a proper rule format
                if (!jsonData.name) {
                    setErrorMsg('Invalid rule format: Missing rule name');
                } else {
                    setErrorMsg('');
                }
            } catch (err) {
                setErrorMsg('Invalid JSON file');
            }
        };
        reader.readAsText(selectedFile);
    };
    
    const handleCreateRule = () => {
        if (!ruleName.trim()) {
            setErrorMsg('Please enter a rule name');
            return;
        }
        
        dispatch(addRule(ruleName.trim()));
        handleView("list");
    };
    
    const handleUploadRule = () => {
        if (!file) {
            setErrorMsg('Please select a file');
            return;
        }
        
        if (errorMsg) {
            // There's a validation error
            return;
        }
        
        // Process the file and add the rule
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const jsonData = JSON.parse(event.target.result);
                const newRule = {
                    id: Date.now().toString(),
                    ruleName: jsonData.name,
                    facts: [], // We'll extract facts from the rule conditions
                    decisions: [] // We'll format the rules to our internal structure
                };
                
                // Extract facts from rules (simplified approach)
                const factsMap = new Map();
                jsonData.rules.forEach(rule => {
                    const conditions = rule.conditions.all || rule.conditions.any || [];
                    conditions.forEach(condition => {
                        if (!factsMap.has(condition.fact)) {
                            factsMap.set(condition.fact, {
                                id: Date.now().toString() + Math.random().toString(36).substr(2),
                                factName: condition.fact,
                                type: typeof condition.value === 'number' ? 'number' : 
                                       typeof condition.value === 'boolean' ? 'boolean' :
                                       Array.isArray(condition.value) ? 'array' :
                                       typeof condition.value === 'object' ? 'object' : 'string'
                            });
                        }
                    });
                });
                
                newRule.facts = Array.from(factsMap.values());
                
                // Format decisions
                newRule.decisions = jsonData.rules.map(rule => ({
                    id: Date.now().toString() + Math.random().toString(36).substr(2),
                    Outcome: rule.event.params.outcome,
                    condition: rule.conditions
                }));
                
                dispatch({ type: 'ADD_RULE', payload: newRule });
                handleView("list");
            } catch (err) {
                setErrorMsg('Error processing rule file');
            }
        };
        reader.readAsText(file);
    };

    return (
        <>
            {addView === "upload" ? (
                <div className="container">
                    <div className='AddRulesPopup'>
                        <div className="PopupInside">
                            <h3><i className="fa fa-cloud-upload" aria-hidden="true"></i> Create / Upload Rules</h3>
                            <div className="fileUploadBtn">
                                <input 
                                    className='uploadFileBtn' 
                                    type='file' 
                                    accept=".json"
                                    onChange={handleFileUpload} 
                                />
                                <div className='text'>
                                    <h5>Choose RuleSet Files</h5>
                                </div>
                            </div>
                            
                            {errorMsg && (
                                <div className="alert alert-danger mt-3">{errorMsg}</div>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
                                <button 
                                    className='addbtn' 
                                    style={{ padding: '12px 35px', marginRight: '15px' }} 
                                    onClick={() => handleUploadRule()}
                                    disabled={!file || !!errorMsg}
                                >
                                    Upload
                                </button>
                                <button 
                                    className='addbtn' 
                                    style={{ padding: '12px 35px' }} 
                                    onClick={() => handleAddView("add")}
                                >
                                    Create
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : ''}

            {addView === "add" ? (
                <div className="container">
                    <div className='AddRulesPopup'>
                        <div className="PopupInside">
                            <h3><i className="fa fa-plus-square" aria-hidden="true"></i> Create Rules</h3>
                            
                            <div className="form-group">
                                <label htmlFor="ruleName">Rule Name</label>
                                <input 
                                    id="ruleName"
                                    type='text' 
                                    className='form-control' 
                                    style={{marginTop:'10px', padding:'15px 10px'}}
                                    value={ruleName}
                                    onChange={(e) => setRuleName(e.target.value)}
                                    placeholder="Enter rule name"
                                />
                            </div>
                            
                            {errorMsg && (
                                <div className="alert alert-danger mt-3">{errorMsg}</div>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                                <button 
                                    className='addbtn' 
                                    style={{ padding: '12px 35px', marginRight: '15px' }} 
                                    onClick={handleCreateRule}
                                >
                                    Create
                                </button>
                                <button 
                                    className='addbtn cancelbtn' 
                                    style={{ padding: '12px 35px' }} 
                                    onClick={() => handleAddView("upload")}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : ''}
        </>
    );
}